interface HomeIconProps {
    className?: string;
}

export default function HomeIcon({ className = "" }: HomeIconProps) {
    return (
        <svg 
            width="24" 
            height="24" 
            viewBox="0 0 48 48" 
            fill="none" 
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path 
                d="M44 44V20L24 4L4 20L4 44H16V26H32V44H44Z" 
                fill="none" 
                stroke="currentColor" 
                strokeWidth="4" 
                strokeLinejoin="round"
            />
        </svg>
    );
}

